@if (items.length > 0) {
  <div class="annotation-list-view mt-3" data-testid="annotation-list-view">
    <div class="fw-bold mb-2" style="color: #719eb6">Annotations</div>
    <ul class="list-unstyled mb-0">
      @for (item of items; track $index) {
        <li class="annotation-list-item py-2 border-bottom">
          <div class="annotation-list-date" style="color: #719eb6; font-size: 0.875rem">
            {{ item.dateLabel }}
          </div>
          <div class="annotation-list-label" style="color: #4a6f82; font-weight: 600">
            {{ item.label }}
          </div>
        </li>
      }
    </ul>
  </div>
} @else {
  <div class="annotation-list-view mt-3 text-center p-3" style="color: #719eb6" data-testid="annotation-list-empty">
    No annotations available
  </div>
}
